import CardMaster, { CGCardSize } from './CardMaster';
import useTheme from '@mui/material/styles/useTheme';
import useMediaQuery from '@mui/material/useMediaQuery';
import ContentSlider from 'components/Slider/ContentSlider';
import React from 'react';
import { CGProduct } from 'types/shopify';

const ProductCardSlider: React.FC<{
  title?: string;
  items: CGProduct[];
  onClick?: (product: any) => void;
  forceCardSize?: CGCardSize;
  hasBadge?: boolean;
  hideTitle?: boolean;
  onClickTitle?: () => void;
  padFirstAndLast?: boolean;
}> = ({ title, items, onClick, forceCardSize, hasBadge = false, hideTitle = false, onClickTitle, padFirstAndLast = false }) => {
  const theme = useTheme();
  const cardSize: CGCardSize = useMediaQuery(theme.breakpoints.down('md')) ? 'small' : 'medium';

  return (
    <ContentSlider title={title} items={items} onClick={onClick} arrowOnHover hideTitle={hideTitle} onClickTitle={onClickTitle} padFirstAndLast={padFirstAndLast}>
      {(items: CGProduct[], onClick: (product: any) => void) =>
        items?.map((product) => (
          <CardMaster
            // The master
            key={product.handle}
            item={product}
            hasBadge={hasBadge}
            size={forceCardSize || cardSize}
            noShrink
            hoverEffect
            onClick={() => onClick && onClick(product)}
          />
        ))
      }
    </ContentSlider>
  );
};

export default ProductCardSlider;
